// skills/bounty/index.js
// Bounty skill registration with skill registry

import { skillRegistry } from '../../core/skillRegistry.js';
import {
    renderBountyUI,
    updateBountyUI,
    initBountyUI,
    switchTab,
    acceptContract,
    abandonContract,
    deliverContract,
    pinContract,
    unpinContract
} from './bountyUI.js';

/**
 * Bounty skill configuration
 * Contract-based progression system for earning gold and XP
 * Includes gathering, processing, and combat (kill) contracts
 */
const bountyConfig = {
    id: 'bounty',
    name: 'Bounty',
    icon: '📜',
    iconImage: 'assets/icons/skill_icons/bounty.png',
    description: 'Accept contracts to earn gold and experience',

    tabs: [
        { id: 'contracts', name: 'Contracts', default: true },
        { id: 'active', name: 'Active' },
    ],

    render(params = {}) {
        renderBountyUI(params);
    },

    update() {
        updateBountyUI();
    },

    init() {
        initBountyUI();
    },

    cleanup() {
        // Nothing to cleanup for now
    }
};

skillRegistry.register('bounty', bountyConfig);

if (typeof window !== 'undefined') {
    window.bountyUI = {
        switchTab,
        acceptContract,
        abandonContract,
        deliverContract,
        pinContract,
        unpinContract
    };
}

export default bountyConfig;
